import React from 'react'
import { IcoMoon, Text, ReturnsBoxIcon, WarrantyBadgeIcon } from '@usap/uicomponents'

const useStaticTexts = props => {
  const {
    applicationData,
    staticTextToUse,
    successData,
    orderDate,
  } = { ...props }

  switch (staticTextToUse) {
    case 'returns':
      return {
        icon: <IcoMoon icon={ReturnsBoxIcon} />,
        headingText: 'Your return request has been submitted.',
        description: (
          <>
            <Text margin={{ bottom: '20px' }} size="small" color="dark-2">
              A return request confirmation has been sent to your email address (
              {applicationData.email}
              ).
            </Text>
            <Text margin={{ bottom: '20px' }} size="small" color="dark-2">
              We&apos;ll review and process your request within 24-72 hours, and
              send a follow-up email with your Return Merchandise Authorization (RMA) number,
              shipping instructions, and refund estimate.
            </Text>
            <Text color="dark-2" size="14px" margin={{ bottom: '5px' }}>
              Order Number:
              {' '}
              <strong>{applicationData.merchantOrderId}</strong>
            </Text>
          </>
        ),
        tableItemDescription: (
          <>
            <Text size="16px" color="dark-2">
              Return ID: &nbsp;
              <Text style={{ display: 'inline-flex' }} weight={700}>{successData}</Text>
            </Text>
            <Text color="dark-2" size="12px" margin={{ bottom: '20px' }}>
              <i>* This is not your RMA number</i>
            </Text>
          </>
        ),
      }
    case 'warrantyClaim':
      return {
        icon: <IcoMoon icon={WarrantyBadgeIcon} />,
        headingText: 'Your warranty claim request has been submitted.',
        description: (
          <>
            <Text size="small" color="dark-2">
              A warranty claim request confirmation has been sent to your email address (
              {applicationData.email}
              ).
            </Text>
            <Text margin={{ bottom: '20px' }} size="small" color="dark-2">
              We&apos;ll review and process your request within 24-72 hours, and
              send a follow-up email.
            </Text>
            <Text color="dark-2" size="14px" margin={{ bottom: '5px' }}>
              Order Number:
              {' '}
              <strong>{applicationData.merchantOrderId}</strong>
            </Text>
            <Text color="dark-2" size="14px" margin={{ bottom: '5px' }}>
              Date Purchased:
              {' '}
              <strong>{orderDate}</strong>
            </Text>
          </>
        ),
        tableItemDescription: (
          <>
            <Text size="16px" color="dark-2">
              Warranty Claim ID: &nbsp;
              <Text style={{ display: 'inline-flex' }} weight={700}>{successData}</Text>
            </Text>
            <Text color="dark-2" size="12px" margin={{ bottom: '20px' }}>
              <i>* This is not your RMA number</i>
            </Text>
          </>
        ),
      }
    default:
      return {
        icon: <></>,
        headingText: '',
        description: <></>,
        tableItemDescription: <></>,
      }
  }
}

export default useStaticTexts
